export default {
  setLoading(state, payload) {
    state.loading = payload;
  },
};
